import { computeFont } from '@/utils/fonts';
import classNames from 'classnames';
import type { TRecommendationAttributes } from '../Recommendations.types';

interface Props {
  children: React.ReactNode;
  attrs: TRecommendationAttributes;
  showForm: boolean;
  isLive: boolean;
}

const PopupElement = ({ children, attrs, showForm, isLive }: Props) => {
  const {
    formBackgroundColor,
    formShadow,
    formPadding,
    formBorderRadius,
    formBorderColor,
    formBorderWidth,
    formBorderStyle,
    fontFamily,
  } = attrs;

  return (
    <div
      className={classNames('fixed bottom-4 right-4 w-80 z-10', showForm || !isLive ? 'block' : 'hidden')}
      style={{
        backgroundColor: formBackgroundColor,
        boxShadow: formShadow,
        padding: formPadding,
        borderRadius: formBorderRadius,
        borderColor: formBorderColor,
        borderWidth: formBorderWidth,
        borderStyle: formBorderStyle,
        fontFamily: computeFont(fontFamily) || 'inherit',
      }}
    >
      {children}
    </div>
  );
};

export default PopupElement;
